import ScrollContainer from 'react-indiana-drag-scroll';

import SpaceY from '../../../../components/SpaceY';
import { Recipe } from '../../../../type';
import { RecipeFlag } from '../../../../type/recipe';
import RecipeCurationCard from '../main/RecipeCurationCard';

import MoreRecipeLink from './MoreRecipeLink';

interface RecipeCurationSlideProps {
  title: string;
  link: string;
  recipes: Recipe[];
  thisWeekVegetables: string[];
  recipeFlag?: RecipeFlag;
}
const RecipeCurationSlide = ({
  title,
  link,
  recipes,
  thisWeekVegetables,
  recipeFlag,
}: RecipeCurationSlideProps) => {
  return (
    <div>
      <div className="px-16px">
        <MoreRecipeLink title={title} link={link} />
      </div>
      <SpaceY height="16px" />
      <ScrollContainer className="flex gap-10px">
        <div className="h-1px w-6px flex-shrink-0" />
        {recipes.map((recipe) => (
          <div key={recipe.id} className="flex-shrink-0">
            <RecipeCurationCard
              recipe={recipe}
              thisWeekVegetables={thisWeekVegetables}
              recipeFlag={recipeFlag}
              curationTitle={title}
            />
          </div>
        ))}
        <div className="h-1px w-6px flex-shrink-0" />
      </ScrollContainer>
    </div>
  );
};

export default RecipeCurationSlide;
